import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import DashboardFilledSvg from "@ant-design/icons-svg/es/asn/DashboardFilled";
import AntdIcon from "../components/AntdIcon";
var DashboardFilled = function DashboardFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DashboardFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  DashboardFilled.displayName = 'DashboardFilled';
}
export default /*#__PURE__*/React.forwardRef(DashboardFilled);